const EmployeeTab = {
    RECORD: 0,
    FILES: 1,
    STATISTIC: 2
}

export default EmployeeTab;